const allowedKeysRegex = /^[0-9]{1}$/

export const routingMask = [
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
]
